import script from "./deviceAmountTuple.vue?vue&type=script&setup=true&lang=ts"
export * from "./deviceAmountTuple.vue?vue&type=script&setup=true&lang=ts"

import "./deviceAmountTuple.vue?vue&type=style&index=0&id=09ffac30&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09ffac30"]])

export default __exports__